import window from 'window-or-global';
import { domBind, domTrigger } from '../../lib/dom-event';
import Confluence from '../../facades/confluence';
import { getRte } from '../../facades/editor';
import { initChunkyTips, cleanupChunkyTips } from './chunky-tips';
import { disableNestedTable, shouldDisableNestedTable } from '../utils/commons';
// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import MacroBrowser from '../utils/macro-browser';

function hintManager(hints) {
	if (!Array.isArray(hints)) {
		throw new Error('Hints passed in must be an array of strings');
	}

	let nextHint = Math.floor(Math.random() * hints.length);

	return {
		getNextHint: () => {
			const hint = hints[nextHint];
			nextHint = (nextHint + 1) % hints.length;
			return hint;
		},
	};
}

export default function adg3Plugin() {
	const Editor = Confluence.Editor;
	const disabledClass = 'disabled';
	const textClassPrefix = 'legacy-color-text-';
	const textClassSelectedSuffix = '-color-picker-selected';
	let justifyButtons;

	function sourceMode() {
		const sourceToggleButton = $('#rte-button-source-mode');
		sourceToggleButton.click(() => {
			if (sourceToggleButton.hasClass('active')) {
				Editor.changeMode(Editor.MODE_RICHTEXT);
			} else {
				Editor.changeMode(Editor.MODE_SOURCE);
			}
		});
	}

	function wireToolbarContext(editor) {
		//not happy about this. Will be finding a better way to wind everything up.
		//don't want the dependence on the TableToolbar want to query for that some how.
		//the levels of async call backs and editor loading here made it hard.
		domTrigger(document, 'initContextToolbars.Toolbar', editor);
		domBind(document, 'createContextToolbarRow.Toolbar', createContextToolbar);
		domBind(document, 'removeContextToolbarRow.Toolbar', removeContextToolbar);
		domBind(document, 'enableContextToolbarRow.Toolbar', enableContextToolbar);
		domBind(document, 'disableContextToolbarRow.Toolbar', disableContextToolbar);

		/*
            Table toolbar init extracted for async loading.
            See  addTableToolbar()
         */
	}

	/**
	 *  Adds bindings to close the dropdown menu when typed or clicked in the RTE
	 */
	function bindCloseDropDown(dd) {
		const closeMenu = () => {
			dd && dd.hide();
		};

		domBind(document, 'showLayer', (e, type, data) => {
			if (type == 'dropdown' && data == dd) {
				const editor = window.tinymce.activeEditor;
				editor.on('Click', closeMenu);
				editor.on('KeyUp', closeMenu);
			}
		});

		domBind(document, 'hideLayer', (e, type, data) => {
			if (type == 'dropdown' && data == dd) {
				const editor = window.tinymce.activeEditor;
				editor.off('Click', closeMenu);
				editor.off('KeyUp', closeMenu);
			}
		});
	}

	//CONFDEV-1921 Formatting should not be allowed inside plain text macro bodies
	function disableDropDown(dropdown) {
		dropdown.addCallback('show', () => {
			if (dropdown.$.parents('.disabled').length) {
				dropdown.hide();
			}
		});
	}

	/**
	 * Binds to the color controls and displays picker when needed
	 */
	function colorPicker() {
		const control = $('#color-picker-control');

		if (!control.length) {
			return;
		}

		const menu = control.find('.aui-dd-parent');
		const changeColorButton = $('#rte-button-color');
		const colorPreview = changeColorButton.find('.selected-color');
		const dropdown = menu.dropDown('Standard', { alignment: 'left' })[0];
		const defaultColor = changeColorButton.attr('data-color');

		const initialColorPreview = `${textClassPrefix}${defaultColor}${textClassSelectedSuffix}`;
		colorPreview.addClass(initialColorPreview);

		control.delegate('a[data-color]', 'click', function (e) {
			const $this = $(this);
			const color = $this.attr('data-color');

			e.preventDefault();
			if ($this.closest('.disabled').length) {
				//if this part of the toolbar is disabled
				return;
			}

			window.tinymce.execCommand('ForeColorName', color);

			changeColorButton.attr('data-color', color);

			colorPreview.removeClass((i, className) => {
				// Removes any previously applied color-specific class
				return (className.match(/(^|\s)legacy-color-text-\S+/g) || []).join(' ');
			});
			colorPreview.addClass(`${textClassPrefix}${color}${textClassSelectedSuffix}`);
		});

		disableDropDown(dropdown);
		bindCloseDropDown(dropdown);
	}

	/**
	 * Binds to the insert table control and displays the picker when needed
	 */
	function tablePicker() {
		getRte().TablePicker.bindToControl(window.tinymce.activeEditor, $('#insert-table-dropdown'));
	}

	function executeToolbarItem(item) {
		const macroName = item.attr('data-macro-name');
		const command = item.attr('data-command');
		const format = item.attr('data-format');
		const controlId = item.attr('data-control-id');
		const editor = window.tinymce.activeEditor;

		if (macroName) {
			MacroBrowser.macroBrowserToolbarButtonClicked({
				presetMacroName: macroName,
			});
		}
		if (command) {
			editor.execCommand(command, false);
		}
		if (format) {
			editor.theme.controlHandlers['formatselect']['click'].dispatch(format);
		}
		if (controlId) {
			editor.theme.controlHandlers['buttons']['click'].dispatch(controlId);
		}
	}

	function enableContextToolbar(e, options) {
		const toolbarId = convertIdToRowId(options);

		$(`#${toolbarId}`).removeClass(disabledClass);
	}

	function disableContextToolbar(e, options) {
		const toolbarId = convertIdToRowId(options);

		$(`#${toolbarId}`).addClass(disabledClass);
	}

	//could be extended to disable a command as well
	function disableToolbarButton(buttonClass) {
		toggleButton($(`.${buttonClass.replace('.', '')}`), true);
	}

	function enableToolbarButton(buttonClass) {
		toggleButton($(`.${buttonClass.replace('.', '')}`), false);
	}

	/**
	 * Used to toggle a button state
	 *
	 * @param {jQueryHTMLElement} $button - Button to be disabled
	 * @param {boolean} disable - DisabledState
	 */
	function toggleButton($button, disable) {
		if (disable) {
			$button
				.closest('.aui-button')
				.prop(disabledClass, true)
				.attr('aria-disabled', 'true')
				.toggleClass(disabledClass, disable);
		} else {
			$button
				.closest('.aui-button')
				.prop(disabledClass, false)
				.removeAttr('aria-disabled')
				.toggleClass(disabledClass, disable);
		}
	}

	function isToolbarButtonEnabled(buttonClass) {
		const button = $(`.${buttonClass.replace('.', '')}`);
		return !button.closest('.aui-button').prop(disabledClass);
	}

	function focusToolbarButton(buttonClass) {
		$(`.${buttonClass.replace('.', '')}`)
			.closest('.aui-button')
			.focus();
	}

	/**
	 * @return the HTML element representing the identified toolbar, or null if not found.
	 */
	function getToolbarRow(id) {
		const rowId = convertIdToRowId({ id });

		const row = $(`#${rowId}`);
		if (row.length) {
			return row[0];
		} else {
			return null;
		}
	}

	/**
	 * Toggles the disabled state of the toolbar buttons
	 *
	 * @param {boolean} state - DisabledState
	 * @param {boolean} [disableFormatState=false] - Defaults to false
	 * @param {boolean} [deep=false] - Disable all inner button and inputs.
	 * @param {function} [deepFilter] - jQuery search filter to run on the inner deep disable, defaults to no filter
	 */
	function toggleToolbarButtons(state, disableFormatState, deep, deepFilter) {
		const toolBar = $('#toolbar');
		const toolBarItems = toolBar.find('.toolbar-item');
		const moreMenu = $('#insert-menu, #more-menu');
		const colorPicker = $('#insert-menu, #color-picker-control');
		const formatMenu = $('#format-dropdown');
		const filter =
			deepFilter ||
			function () {
				return true;
			};

		toolBarItems.toggleClass(disabledClass, state);
		moreMenu.toggleClass(disabledClass, state);
		colorPicker.toggleClass(disabledClass, state);

		// format should not disabled by default
		formatMenu.toggleClass(disabledClass, !!disableFormatState);
		getRte().TablePicker[state ? 'disable' : 'enable']();

		// Disable all inner buttons and inputs applied over a filter
		typeof deep !== 'undefined' &&
			toolBar
				.find('button, input')
				.filter(filter)
				.toggleClass(disabledClass, deep)
				.prop(disabledClass, deep);
	}

	const disableToolbarButtons = (editor) => {
		const shouldDisable = (node) => {
			node = $(node).closest('PRE,BLOCKQUOTE,.text-placeholder');
			return (type) => {
				return node.is(type);
			};
		};

		return (e) => {
			const element = e.element;
			const isType = shouldDisable(element);
			const isBlockQuote = isType('BLOCKQUOTE');
			const isPre = isType('PRE');
			const isPlaceholder = isType('.text-placeholder');
			let isInsideNoFormatMacro;

			if (isPre) {
				//check to see if we area also in a macro
				isInsideNoFormatMacro = $(element)
					.parents('table')
					.is("[data-macro-body-type='PLAIN_TEXT']");
				toggleToolbarButtons(true, isInsideNoFormatMacro);
			} else if (isPlaceholder) {
				toggleToolbarButtons(true);
			} else if (isBlockQuote) {
				// re-enable all then
				toggleToolbarButtons(false);
				// disable justification buttons.
				justifyButtons.toggleClass(disabledClass, true);
			} else {
				//re-enable everything
				toggleToolbarButtons(false);
			}

			// CFE-394
			disableNestedTable($(element), getRte().TablePicker, editor);
		};
	};

	// Convert a supplied value to a value suitable for identifying a toolbar row
	function convertIdToRowId(options) {
		let toolbarId = 'default';
		if (options && options.id) {
			toolbarId = options.id;
		}

		return `rte-toolbar-row-${toolbarId}`;
	}

	// check if a toolbar with the supplied id already exists
	function isAlreadyPresent(val) {
		return $(`#${val}`).length > 0;
	}

	/**
	 * @return true if the identifier toolbar is enabled.
	 */
	function isToolbarRowEnabled(id) {
		const toolbarId = convertIdToRowId({ id });

		return isAlreadyPresent(toolbarId) && !$(`#${toolbarId}`).hasClass(disabledClass);
	}

	function removeContextToolbar(e, options) {
		let animate = options.animate;
		if (animate == undefined) {
			animate = true;
		}

		const callback = function () {
			$(this).remove();
			domTrigger(document, 'resize.resizeplugin');
			if (options.onHide) {
				options.onHide();
			}
		};

		const toolbarId = convertIdToRowId(options);
		const toolbar = $(`#${toolbarId}`);
		if (animate) {
			toolbar.addClass('disabled');
		} else {
			toolbar.addClass('disabled');
			callback.call(toolbar);
		}
	}

	/**
	 * options.editorAdjacent - if true then the toolbar is preferred to remain the nearest one to the editor
	 * even when later toolbars are opened.
	 */
	function createContextToolbar(e, options) {
		const toolbarId = convertIdToRowId(options);
		if (isAlreadyPresent(toolbarId)) {
			return;
		}

		let animate = options.animate;
		if (animate == undefined) {
			animate = true;
		}

		const row = $('<div></div>').addClass(
			'toolbar-split toolbar-split-row toolbar-contextual disabled',
		);

		row.attr('id', toolbarId);

		if (options.editorAdjacent) {
			row.addClass('editor-adjacent');
		}

		//CONFDEV-39705: select toolbar which is visible to make sure it is element of active editor
		const toolbar = !options.topToolbar
			? $('#savebar-container .aui-toolbar:visible')
			: $('#rte-toolbar.aui-toolbar:visible');
		for (let i = 0, length = options.buttons.length; i < length; i++) {
			const btn = options.buttons[i];
			row.append(btn.render());
		}

		if (options.editorAdjacent) {
			toolbar.append(row);
		} else {
			// insert this new toolbar immediately before the first editorAdjacent one found
			const firstEditorAdjacentToolbar = $('.editor-adjacent', toolbar).filter(':first');
			if (firstEditorAdjacentToolbar.length) {
				firstEditorAdjacentToolbar.before(row);
			} else {
				toolbar.append(row);
			}
		}

		row.find('.toolbar-dropdown').each(function () {
			bindDropdownMenu(this);
		});

		const callback = () => {
			domTrigger(document, 'resize.resizeplugin');
			domTrigger(document, 'shown.contextToolbar');
			if (options.onVisible) {
				options.onVisible();
			}
		};

		if (!animate) {
			callback();
		}
		row.removeClass('disabled');
	}

	function bindDropdownMenu(id) {
		const menu = $(id);
		const dropdown = menu.dropDown('Standard', {
			alignment: menu.data('dropdown-alignment') || 'left',
		})[0];

		menu.find('.dropdown-item').click(function (e) {
			const item = $(this);
			executeToolbarItem(item, e);
			dropdown.hide();
			e.preventDefault();
		});

		disableDropDown(dropdown);
		bindCloseDropDown(dropdown);
	}

	function editorHints() {
		const TinyMCELang = { hints: {} }; // TODO: get this from editor.
		const hints = [];
		for (const hint in TinyMCELang.hints) {
			hints.push(`hints.${hint}`);
		}
		const _hintManager = hintManager(hints);
		const updateHint = () => {
			$('#rte-savebar .hints-text').html(
				window.tinymce.activeEditor.translate(`tinymce.${_hintManager.getNextHint()}`),
			);
		};
		updateHint();
		$('#rte-savebar a.hints-close').click(function (e) {
			$(this).closest('.toolbar-split').addClass('hidden');
			e.preventDefault();
		});
		$('#rte-savebar a.hints-next').click((e) => {
			updateHint();
			e.preventDefault();
		});
	}

	function cacheElement() {
		justifyButtons = $(
			'#rte-button-justifyleft, #rte-button-justifycenter, #rte-button-justifyright',
		);
	}

	return {
		init(ed) {
			bindDropdownMenu('#format-dropdown');
			bindDropdownMenu('#more-menu .aui-dd-parent');
			bindDropdownMenu('#insert-menu .aui-dd-parent');
			if ($('#pagelayout-menu').length) {
				bindDropdownMenu('#pagelayout-menu .aui-dd-parent');
			}
			if ($('#template-menu').length) {
				bindDropdownMenu('#template-menu .aui-dd-parent');
			}

			colorPicker();
			tablePicker();
			sourceMode();
			editorHints();
			cacheElement();

			// TODO: we still need to think about this
			wireToolbarContext(ed);

			const formatDropDown = $('#format-dropdown');
			const dropDownTextHolder = formatDropDown.find('span.dropdown-text');

			ed.on('BeforeExecCommand', (e) => {
				// "context" removed from function signature.

				const cmd = e.command;
				const val = e.value;
				const ed = window.tinymce.activeEditor;
				// CONFDEV-3535: Reset to left alignment if in style that does not support alignment.
				$.each(['pre', 'blockquote'], function () {
					if (cmd == 'FormatBlock' && val == this) {
						ed.formatter.remove('alignleft');
						ed.formatter.remove('aligncenter');
						ed.formatter.remove('alignright');
					}
				});

				// CONFDEV-767/CONFDEV-1408: Prevent styles, links and macros from being used within a pre block or text placeholder.
				if ($(ed.selection.getNode()).closest('pre,.text-placeholder').length) {
					const toDisable = [
						'Bold',
						'Italic',
						'Underline',
						'Strikethrough',
						'InsertUnorderedList',
						'InsertOrderedList',
						'InsertInlineTaskList',
						'InsertInlineTaskListNoToggle',
						'superscript',
						'subscript',
						'mceConfMacroBrowser',
						'mceConfimage',
						'mceConfAttachments',
						'mceEmotion',
						'InsertWikiMarkup',
						'mceConflink',
						'mceInsertTable',
						'mceConfAutocompleteLink',
					];
					const toDisableLen = toDisable.length;

					for (let i = 0; i < toDisableLen; i++) {
						if (cmd == toDisable[i]) {
							e.preventDefault();
						}
					}
				}

				// Remove existing formatting before applying a pre style.
				if (cmd == 'FormatBlock' && val == 'pre') {
					ed.undoManager.add();
					ed.execCommand('removeFormat');
				}

				// Block
				// if going from blockquote to paragraph format, we need to execute the
				// blockquote command again to remove formatting - that's just how tinymce works
				if (cmd == 'FormatBlock' && val == 'p') {
					const blockquote = formatDropDown.find(".dropdown-item[data-format='blockquote']").text();
					if (dropDownTextHolder.text() == blockquote) {
						ed.execCommand('FormatBlock', false, 'blockquote');
					}
				}

				if (cmd === 'confDefaultTable' && shouldDisableNestedTable($(ed.selection.getNode()))) {
					// disable insert nested table via shortcut Cmd+Shift+I
					e.preventDefault();
				}
			});

			// Update format dropdown display text
			ed.on('ExecCommand', (e) => {
				const cmd = e.command;
				const val = e.value;
				if (cmd == 'FormatBlock') {
					let format = formatDropDown.find(`.dropdown-item[data-format='${val}']`);
					if (!format.length) {
						// default to paragraph format
						format = formatDropDown.find(".dropdown-item[data-format='p']");
					}
					dropDownTextHolder.text(format.text());
				}
			});

			ed.on('NodeChange', disableToolbarButtons(ed));

			ed.on('init', () => {
				const ed = window.tinymce.activeEditor;
				if (process.env.NODE_ENV !== 'production') {
					console.debug('customtoolbar: ed.onInit function');
				}
				const toolbarButtons = {};
				$('.aui-toolbar')
					.find('[data-control-id]')
					.each((i, trigger) => {
						let control;

						trigger = $(trigger);
						const id = trigger.attr('data-control-id');

						if (id == 'formatselect') {
							// bindings for format drop down
							control = ed.theme.controlHandlers[id];
							control['state'].add((name) => {
								const editor = window.tinymce.activeEditor;
								if (name == 'p') {
									const n = editor.selection.getNode();
									// fix bug in advanced theme where it always shows paragraph format when in a blockquote
									if ($(n).closest('p').parent().is('blockquote')) {
										name = 'blockquote';
									}
								}
								const text = formatDropDown.find(`.dropdown-item[data-format='${name}']`).text();
								if (text) {
									dropDownTextHolder.text(text);
								}
							});
						} else {
							toolbarButtons[id] = trigger;
						}
					});

				const control = ed.theme.controlHandlers['buttons'];

				//state can be: 'disabled' or 'active'
				control['state'].add((format, state, toggle) => {
					const button = toolbarButtons[format];

					if (!button) {
						return;
					}

					const icon = button.find('.icon-check');

					const toolbarItem = button.closest('.toolbar-item');

					if (!icon.length) {
						toolbarItem.toggleClass(state, toggle);
					} else {
						icon.toggleClass('hidden', !toggle);
					}
				});

				$('.aui-toolbar').delegate('.toolbar-item', 'click', function (e) {
					const $self = $(this);
					if (!$self.hasClass('disabled')) {
						const format = $self
							.children('.toolbar-trigger[data-control-id]')
							.attr('data-control-id');
						if (format) {
							control['click'].dispatch(format);
							e.preventDefault();
						}
					} else {
						// stop activation of navigation to # (i.e. top of page) when disabled
						e.preventDefault();
					}
				});

				// https://jira.atlassian.com/browse/CONFDEV-11912#comment-439048
				$.support.shrinkWrapBlocks = false;

				if (process.env.NODE_ENV !== 'production') {
					console.debug('customtoolbar: finished ed.onInit function');
				}

				initChunkyTips();
			});
			//CONFDEV-55148
			ed.on('Remove', () => {
				cleanupChunkyTips();
			});

			//CONFDEV-58284
			ed.on('Focus', () => {
				const $currentNode = $(ed.selection.getNode());
				disableNestedTable($currentNode, getRte().TablePicker, ed);
			});
		},
		toggleToolbarButton: toggleButton,
		disableToolbarButton,
		enableToolbarButton,
		focusToolbarButton,
		isToolbarRowEnabled,
		getToolbarRow,
		isToolbarButtonEnabled,
		bindDropdownMenu,
		toggleToolbarButtons,

		getInfo: () => {
			return {
				longname: 'customtoolbar',
				author: 'Atlassian',
				authorurl: 'http://www.atlassian.com',
				infourl: 'http://www.atlassian.com/',
				version: '1.0',
			};
		},
	};
}
